import './state-input.scss';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

import { Input, ValidationStates } from './input';
export { ValidationStates } from './input';

@Component({
    components: {
        sInput: Input,
    },
    props: ['active', 'validator'],
    template: require('./state-input.html'),
})
export class StateInput extends ReactiveVue {
    public defaultValue: string;
    public active: boolean;
    public validator: (value: string) => boolean;

    public $refs: {
        input: Input;
    };

    public ValidationStates = ValidationStates;
    public validationState: ValidationStates = ValidationStates.PENDING;

    private input$ = new Subject<string>();

    public mounted() {
        this.subscribeTo(
            this.input$.pipe(
                debounceTime(500),
                distinctUntilChanged(),
                filter(() => this.active && this.validationState !== ValidationStates.SUCCESS),
            ),
            async value => {
                if (!value) {
                    this.validationState = ValidationStates.PENDING;
                    return;
                }

                this.validationState = ValidationStates.VALIDATING;

                try {
                    this.validationState = (await this.validator(value))
                        ? ValidationStates.SUCCESS
                        : ValidationStates.ERROR;
                } catch (error) {
                    this.validationState = ValidationStates.ERROR;
                }
            },
        );
    }

    public reset() {
        this.validationState = ValidationStates.PENDING;
        this.$refs.input.clear();
    }

    public validate(value) {
        this.validationState = ValidationStates.SUCCESS;
        this.$refs.input.write(value);
    }

    public onInputChange(value) {
        this.input$.next(value);
    }

    @Watch('validationState', { immediate: false })
    private onValidationStateChange(value: ValidationStates) {
        switch (value) {
            case ValidationStates.ERROR:
                this.$emit('error');
                break;

            case ValidationStates.SUCCESS:
                this.$refs.input.blur();
                break;

            default:
                break;
        }

        this.$emit('change', value, this.$refs.input.value);
    }

    @Watch('active', { immediate: false })
    private onActiveChange(value) {
        if (
            !value &&
            (this.validationState === ValidationStates.PENDING ||
                this.validationState === ValidationStates.ERROR)
        ) {
            this.reset();
        }
    }
}
